import { DateTimeFormat } from './types';
import enUS from './locales/en-US';
import frFR from './locales/fr-FR';
import itIT from './locales/it-IT';
import esES from './locales/es-ES';
var en = enUS;
var fr = frFR;
var it = itIT;
var es = esES;
export var formatListPerLocale = {
    en: en,
    'en-US': enUS,
    fr: fr,
    'fr-FR': frFR,
    it: it,
    'it-IT': itIT,
    es: es,
};
export { DateTimeFormat };
